
import { defineComponent, reactive, toRefs, PropType, watch, computed } from 'vue'
import moment, { MomentInput } from 'moment'
import 'moment-timezone'
import Datepicker from 'vue3-datepicker/src/datepicker/Datepicker.vue'
import { RESOLUTIONS } from './ResolutionSelector.vue'
import { ja } from 'date-fns/locale'

moment.tz.setDefault('Asia/Tokyo')

type StateTypes = {
  minute: number
  hour: number
  targetDate: Date
  minimumView: 'minute' | 'day' | 'month' | 'year'
  inputFormat: string
}

export default defineComponent({
  props: {
    resolution: {
      type: String,
      default: RESOLUTIONS.HOUR,
    },
    modelValue: {
      type: Date as PropType<Date>,
      default: () => new Date(),
    },
    showHour: {
      type: Boolean,
      default: false,
    },
    showMinutes: {
      type: Boolean,
      default: false,
    },
    hideMinuteSelector: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    Datepicker,
  },
  setup(props, { emit }) {
    const state = reactive<StateTypes>({
      minute: props.showMinutes
        ? props.modelValue.getMinutes()
        : props.modelValue.getMinutes() - (props.modelValue.getMinutes() % (props.resolution === 'ten_min' ? 10 : 5)),
      hour: props.modelValue.getHours(),
      targetDate: props.modelValue,
      minimumView: 'day',
      inputFormat: 'yyyy年MM月dd日',
    })

    const handleChangeResolution = () => {
      switch (props.resolution) {
        case RESOLUTIONS.RUISEKI:
          state.minimumView = 'month'
          state.inputFormat = 'yyyy年MM月'
          break
        case RESOLUTIONS.MINUTE:
          state.minimumView = 'day'
          state.inputFormat = 'yyyy年MM月dd日'
          break
        case RESOLUTIONS.HOUR:
          state.minimumView = 'day'
          state.inputFormat = 'yyyy年MM月dd日'
          break
        case RESOLUTIONS.DAY:
          state.minimumView = 'day'
          state.inputFormat = 'yyyy年MM月dd日'
          break
        case RESOLUTIONS.MONTH:
          state.minimumView = 'month'
          state.inputFormat = 'yyyy年MM月'
          break
        case RESOLUTIONS.YEAR:
          state.minimumView = 'year'
          state.inputFormat = 'yyyy年'
          break
      }
    }

    const currentDatetime = computed(() => {
      const { minute, hour, targetDate } = state

      return moment(targetDate as MomentInput)
        .minute(minute)
        .hour(hour)
        .toDate()
    })

    const isCamera = computed(() => {
      return props.resolution.includes('history_')
    })

    handleChangeResolution()

    watch(
      () => moment(currentDatetime.value).format('YYYYMMDDHHmm'),
      () => {
        emit('update:modelValue', currentDatetime.value)
      }
    )

    watch(
      () => props.modelValue,
      () => {
        state.minute = props.modelValue.getMinutes()
        state.hour = props.modelValue.getHours()
        state.targetDate = props.modelValue
      }
    )

    watch(() => props.resolution, handleChangeResolution)

    return {
      ...toRefs(state),
      ja,
      currentDatetime,
      isCamera,
    }
  },
})
